import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ItemsToTranslate, ObjectToTranslate, TranslationContent, TranslationNode, TranslationRequest, TranslationResponse } from '../api/models/translation';
import { ServiceURLConstants } from '../constants/upplm.constants';
import { UPPLM_TRANSLATIONS } from '../constants/upplm.constants.translations';
import { UpsCommonService } from './upplm.common.service';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })

};

@Injectable()
export class TranslationService {

    request: TranslationRequest;
    translations: TranslationNode;
    translationValues: any[] = [];
    constructor(private httpclient: HttpClient, private _commonService: UpsCommonService) {

    }

    prepareRequest(locale: string): TranslationRequest {
        this.request = new TranslationRequest();
        this.request.locale = locale;
        this.request.content = new TranslationNode();
        this.request.content.tpc_key_upplm = new TranslationContent();
        this.request.content.tpc_key_upplm.translations = this.getTranslationRequest();
        return this.request;
    }

    private getTranslationRequest(): ItemsToTranslate {
        let req = new ItemsToTranslate();
        req.items = [];
        UPPLM_TRANSLATIONS.forEach(valueToTranslate => {
            let objectToTranslate = new ObjectToTranslate(valueToTranslate.key, valueToTranslate.default);
            req.items.push(objectToTranslate);
        });
        return req;
    }

    getProxyTranslations(request: TranslationRequest): Observable<TranslationResponse> {
        let url = ServiceURLConstants.GET_TRANSLATIONS;
        return this.httpclient.post<TranslationResponse>(url, request).pipe(
            map(resp => {
                return resp;
            })
        );
    }

    public getTranslationValues(): any[] {
        return this.translationValues;
    }
    public getTranslationResponse(): TranslationNode {
        return this.translations;
    }

    load() {
        let url = ServiceURLConstants.GET_TRANSLATIONS;
        return new Promise((resolve, reject) => {
            this.httpclient
                .post<TranslationResponse>(url, this.prepareRequest(this._commonService.locale))
                .pipe(
                    map(resp => { return resp }))
                .subscribe(response => {
                    this.translationValues = response.tpC_KEY_UPPLM ? this.getKeyValuesFromTranslations(response.tpC_KEY_UPPLM) : [];                    
                    resolve(true);
                })
        })
    }

    getKeyValuesFromTranslations(translationNode: TranslationNode): any[] {
        let parentSection: TranslationContent;
        parentSection = translationNode['translations'];
        let values: any[] = parentSection['items'];
        return values;
    }
}